import React from "react";
import { useMyContext } from "../../ContextApi";
import { AppRoutes } from "../../utils/AppRoutes";
import { useNavigate } from "react-router-dom";
import placeholderImage from "../../assets/placeholderImage.svg"

interface HeaderComponentProp {
  nameOfPage?: string
  pageName?: string;
  count: number;
  setCount: React.Dispatch<React.SetStateAction<number>>;
}

export function HeaderComponent({ pageName, count, nameOfPage }: HeaderComponentProp) {
  const { userInfo, setIsMobileSidebarOpen } = useMyContext();
  const navigate = useNavigate();
  const handleClick = () => {
    window.history.back();
  };
  return (
    <div className={pageName === "My Profile" ? "partypal-header center" : "partypal-header"}>
      <div className='page-heading flex gap-2  justify-center items-center'>
        {count == 1 && (
          <svg
            onClick={handleClick}
            style={{ cursor: "pointer" }}
            xmlns='http://www.w3.org/2000/svg'
            width='11'
            height='20'
            viewBox='0 0 11 20'
            fill='none'
          >
            <path
              d='M10.3724 0.98491C10.2563 0.868502 10.1184 0.776145 9.96653 0.713129C9.81467 0.650113 9.65186 0.617676 9.48744 0.617676C9.32303 0.617676 9.16022 0.650113 9.00836 0.713129C8.8565 0.776145 8.71856 0.868502 8.60244 0.98491L0.292444 9.29491C0.199741 9.38742 0.126193 9.49731 0.0760117 9.61829C0.0258302 9.73926 0 9.86894 0 9.99991C0 10.1309 0.0258302 10.2606 0.0760117 10.3815C0.126193 10.5025 0.199741 10.6124 0.292444 10.7049L8.60244 19.0149C9.09244 19.5049 9.88245 19.5049 10.3724 19.0149C10.8624 18.5249 10.8624 17.7349 10.3724 17.2449L3.13244 9.99491L10.3824 2.74491C10.8624 2.26491 10.8624 1.46491 10.3724 0.98491Z'
              fill='#262626'
            />
          </svg>
        )}
        {
          nameOfPage == "dashboard"
          &&
        <img
          className="block md:hidden h-[28px] w-[28px] rounded-full"
          onClick={() => {
            if(window.innerWidth <= 768){
              setIsMobileSidebarOpen(true)
              console.log("clicked")
            }
          }}
          src={userInfo.profilePicture ? userInfo.profilePicture : placeholderImage}
          alt='profilepic'
        />
        }
        {count == 1 && (pageName == "Order Request" || pageName == "Offer") ? <></> : <p>{pageName}</p>}
      </div>
      <div className='partypal-header-img-contsiner'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          onClick={() => navigate(AppRoutes.V_NOTIFICATION)}
          width='24'
          height='26'
          viewBox='0 0 24 26'
          fill='none'
        >
          <path
            d='M7.66667 19.6667V21C7.66667 22.0609 8.08809 23.0783 8.83824 23.8284C9.58838 24.5786 10.6058 25 11.6667 25C12.7275 25 13.7449 24.5786 14.4951 23.8284C15.2452 23.0783 15.6667 22.0609 15.6667 21V19.6667M9 3.66667C9 2.95942 9.28095 2.28115 9.78105 1.78105C10.2811 1.28095 10.9594 1 11.6667 1C12.3739 1 13.0522 1.28095 13.5523 1.78105C14.0524 2.28115 14.3333 2.95942 14.3333 3.66667C15.8645 4.3907 17.1699 5.51777 18.1094 6.92707C19.0489 8.33636 19.5873 9.97476 19.6667 11.6667V15.6667C19.767 16.4956 20.0606 17.2894 20.5238 17.9842C20.9869 18.6789 21.6067 19.2552 22.3333 19.6667H1C1.72658 19.2552 2.34641 18.6789 2.80958 17.9842C3.27275 17.2894 3.56633 16.4956 3.66667 15.6667V11.6667C3.74608 9.97476 4.2844 8.33636 5.22393 6.92707C6.16346 5.51777 7.46879 4.3907 9 3.66667Z'
            stroke='#262626'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
        <img
          onClick={() => {
            navigate(AppRoutes.V_PROFILE);
          }}
          src={userInfo.profilePicture ? userInfo.profilePicture : placeholderImage}
          alt='profilepic'
        />
      </div>
    </div>
  );
}

export default HeaderComponent;
